module.exports = __webpack_public_path__ + "img/ydy.25fe60c3.png";